var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "门店",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("store-tenant-select", {
                                    attrs: { domain: "stock" },
                                    on: { change: _vm.handleStoreTenantChange },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 5, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "仓库",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        mode: "multiple",
                                        maxTagCount: 1,
                                        optionFilterProp: "children",
                                        showSearch: "",
                                        placeholder: "请选择仓库",
                                      },
                                      model: {
                                        value: _vm.depotSelected,
                                        callback: function ($$v) {
                                          _vm.depotSelected = $$v
                                        },
                                        expression: "depotSelected",
                                      },
                                    },
                                    _vm._l(
                                      _vm.depotList,
                                      function (depot, index) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: index,
                                            attrs: { value: depot.id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(depot.depotName) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "商品信息",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder:
                                        "请输入条码、名称、助记码、规格、型号等信息",
                                    },
                                    model: {
                                      value: _vm.queryParam.materialParam,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "materialParam",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.materialParam",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                            _c(
                              "span",
                              {
                                staticClass: "table-page-search-submitButtons",
                                staticStyle: {
                                  float: "left",
                                  overflow: "hidden",
                                },
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.searchQuery },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "print",
                                        rawName: "v-print",
                                        value: "#reportPrint",
                                        expression: "'#reportPrint'",
                                      },
                                    ],
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                  },
                                  [_vm._v("打印")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportExcel },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: { click: _vm.handleToggleSearch },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.toggleSearchStatus
                                            ? "收起"
                                            : "展开"
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("a-icon", {
                                      attrs: {
                                        type: _vm.toggleSearchStatus
                                          ? "up"
                                          : "down",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "a-col",
                            { attrs: { md: 7, sm: 24 } },
                            [
                              _c("a-form-item", [
                                _vm.showStockPrice
                                  ? _c("span", [
                                      _vm._v(
                                        "总库存：" +
                                          _vm._s(_vm.currentStock) +
                                          "，总库存金额：" +
                                          _vm._s(_vm.currentStockPrice) +
                                          "，总重量：" +
                                          _vm._s(_vm.currentWeight)
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.showStockPrice
                                  ? _c("span", [
                                      _vm._v(
                                        "总库存：" +
                                          _vm._s(_vm.currentStock) +
                                          "，总重量：" +
                                          _vm._s(_vm.currentWeight)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.toggleSearchStatus
                        ? [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 5, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "类别",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-tree-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            dropdownStyle: {
                                              maxHeight: "200px",
                                              overflow: "auto",
                                            },
                                            "allow-clear": "",
                                            treeData: _vm.categoryTree,
                                            placeholder: "请选择类别",
                                          },
                                          model: {
                                            value: _vm.queryParam.categoryId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "categoryId",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.categoryId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "仓位货架",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "请输入仓位货架查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.position,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "position",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.position",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "零库存",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            model: {
                                              value: _vm.queryParam.zeroStock,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "zeroStock",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.zeroStock",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("隐藏")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "1" } },
                                              [_vm._v("显示")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "section",
                { ref: "print", attrs: { id: "reportPrint" } },
                [
                  _c(
                    "a-table",
                    {
                      ref: "table",
                      attrs: {
                        bordered: "",
                        size: "middle",
                        rowKey: "id",
                        columns: _vm.columns,
                        dataSource: _vm.dataSource,
                        components: _vm.handleDrag(_vm.columns),
                        pagination: false,
                        scroll: _vm.scroll,
                        loading: _vm.loading,
                      },
                      on: { change: _vm.handleTableChange },
                      scopedSlots: _vm._u([
                        {
                          key: "action",
                          fn: function (text, record) {
                            return _c(
                              "span",
                              {},
                              [
                                _vm.showStockPrice
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showMaterialInOutList(
                                              record
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(record.id ? "流水" : ""))]
                                    )
                                  : _vm._e(),
                                _vm.showStockPrice
                                  ? _c("a-divider", {
                                      attrs: { type: "vertical" },
                                    })
                                  : _vm._e(),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.showMaterialDepotStockList(
                                          record
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(record.id ? "分布" : ""))]
                                ),
                              ],
                              1
                            )
                          },
                        },
                        {
                          key: "customPic",
                          fn: function (text, record) {
                            return [
                              _c(
                                "a-popover",
                                {
                                  attrs: {
                                    placement: "right",
                                    trigger: "click",
                                  },
                                },
                                [
                                  _c("template", { slot: "content" }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.getImgUrl(
                                          record.imgName,
                                          record.imgLarge
                                        ),
                                        width: "500px",
                                      },
                                    }),
                                  ]),
                                  record.imgName
                                    ? _c("div", { staticClass: "item-info" }, [
                                        record.imgName
                                          ? _c("img", {
                                              staticClass: "item-img",
                                              attrs: {
                                                src: _vm.getImgUrl(
                                                  record.imgName,
                                                  record.imgSmall
                                                ),
                                                title: "查看大图",
                                              },
                                            })
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                        {
                          key: "customRenderStock",
                          fn: function (text, record) {
                            return [
                              _c(
                                "a-tooltip",
                                { attrs: { title: record.bigUnitStock } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(text) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "customTitle" }, slot: "customTitle" },
                        [
                          _c(
                            "a-popover",
                            { attrs: { trigger: "click", placement: "right" } },
                            [
                              _c(
                                "template",
                                { slot: "content" },
                                [
                                  _c(
                                    "a-checkbox-group",
                                    {
                                      attrs: {
                                        defaultValue: _vm.settingDataIndex,
                                      },
                                      on: { change: _vm.onColChange },
                                      model: {
                                        value: _vm.settingDataIndex,
                                        callback: function ($$v) {
                                          _vm.settingDataIndex = $$v
                                        },
                                        expression: "settingDataIndex",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-row",
                                        { staticStyle: { width: "600px" } },
                                        [
                                          _vm._l(
                                            _vm.defColumns,
                                            function (item, index) {
                                              return [
                                                [
                                                  _c(
                                                    "a-col",
                                                    { attrs: { span: 6 } },
                                                    [
                                                      item.dataIndex ===
                                                      "rowIndex"
                                                        ? _c("a-checkbox", {
                                                            attrs: {
                                                              value:
                                                                item.dataIndex,
                                                              disabled: "",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      item.dataIndex !==
                                                      "rowIndex"
                                                        ? _c(
                                                            "a-checkbox",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  item.dataIndex,
                                                              },
                                                            },
                                                            [
                                                              _c("j-ellipsis", {
                                                                attrs: {
                                                                  value:
                                                                    item.title,
                                                                  length: 10,
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "a-row",
                                        {
                                          staticStyle: {
                                            "padding-top": "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-col",
                                            [
                                              _vm._v(
                                                "\n                      恢复默认列配置："
                                              ),
                                              _c(
                                                "a-button",
                                                {
                                                  attrs: {
                                                    type: "link",
                                                    size: "small",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleRestDefault,
                                                  },
                                                },
                                                [_vm._v("恢复默认")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("a-icon", { attrs: { type: "setting" } }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "a-row",
                    {
                      staticStyle: {
                        "margin-top": "8px",
                        "text-align": "right",
                      },
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 24, sm: 24 } },
                        [
                          _c("a-pagination", {
                            attrs: {
                              size: "small",
                              "show-size-changer": "",
                              showQuickJumper: true,
                              current: _vm.ipagination.current,
                              "page-size": _vm.ipagination.pageSize,
                              "page-size-options":
                                _vm.ipagination.pageSizeOptions,
                              total: _vm.ipagination.total,
                              "show-total": (total, range) =>
                                `共 ${
                                  total -
                                  Math.ceil(total / _vm.ipagination.pageSize)
                                } 条`,
                            },
                            on: {
                              change: _vm.paginationChange,
                              showSizeChange: _vm.paginationShowSizeChange,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "buildOptionText",
                                fn: function (props) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(props.value - 1) + "条/页"),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("material-in-out-list", {
                ref: "materialInOutList",
                on: { ok: _vm.modalFormOk },
              }),
              _c("material-depot-stock-list", {
                ref: "materialDepotStockList",
                on: { ok: _vm.modalFormOk },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }